import { useEffect, useState } from 'react'
import SliderImages from '../../component/CustomSlider/SliderImages'
import './style.css'
import DateRangeSelector from '../Flights/Dropdown/DateSelector'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import {
  setLoadingFalse,
  setLoadingTrue
} from '../../Config/Actions/loadingActions'
import axios from 'axios'
import { Country } from 'country-state-city'
import SearchDropdown from '../Flights/Dropdown/SearchDropdown'
import EndDateSelector from '../Flights/Dropdown/endDateSelector'

const Insurance = () => {
  const [sliderImages, setSliderImages] = useState([])
  const [flightsForm, setFlightsForm] = useState([])
  const [dateRangeOpen, setDateRangeOpen] = useState(false)
  const [success, setSuccess] = useState(false)
  const [endOpen, setDateEndOpen] = useState(false)

  useEffect(() => {
    fetch('/PackageJson/Insurance/InsuranceImages.json')
      .then(response => response.json())
      .then(data => {
        setSliderImages(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])
  useEffect(() => {
    fetch('/PackageJson/Insurance/InsuranceForm.json')
      .then(response => response.json())
      .then(data => {
        setFlightsForm(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])

  const [formData, setFormData] = useState({
    full_name: '',
    contact: '',
    email: '',
    product_type: 'hotels',
    departureDate: '',
    returnDate: '',
    age: '',
    Country: ''
  })
  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }
  const dispatch = useDispatch()
  const handleSubmit = async e => {
    e.preventDefault()
    dispatch(setLoadingTrue())
    const FormData = {
      to: formData.email,
      subject: 'Insurance',
      fullName: formData.full_name,
      Email: formData.email,
      Contact: formData.contact,
      startDate: moment(formData.departureDate).format('DD MMM YYYY'),
      EndDate: moment(formData.returnDate).format('DD MMM YYYY'),
      Age: formData.age,
      country: formData.Country
    }

    try {
      const response = await axios.post(
        'https://arrshiyanatravels.com/api/send_email.php',
        FormData
      )
      dispatch(setLoadingFalse())
      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
      setFormData(prevState => ({
        ...prevState,
        full_name: '',
        contact: '',
        email: '',
        product_type: 'hotels',
        departureDate: '',
        returnDate: '',
        age: '',
        Country: ''
      }))
    } catch (error) {
      console.error('Error submitting form:', error)
    }
  }
  const handleCountrySelect = selectedCountry => {
    setFormData(prevState => ({
      ...prevState,
      Country: selectedCountry
    }))
  }
  const handleOnchangeDate = item => {
    setFormData(prevState => ({
      ...prevState,
      departureDate: item.selection.startDate
    }))
  }
  const handleOnchangeEndOpen = item => {
    setFormData(prevState => ({
      ...prevState,
      returnDate: item.selection.startDate
    }))
  }
  return (
    <div>
      <div className='hotels Holidays'>
        <div
          style={{
            height: '',
            backgroundImage: `url(${flightsForm[0]?.displayBackground})`,
            backgroundPosition: 'center',
            backgroundSize: 'Cover',
            backgroundRepeat: 'no-repeat',
            padding: '80px 0px'
          }}
          className='product-container'
        >
          <div className='container'>
            <div className='product-area'>
              <p>Travel Insurance Plan</p>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-lg-5 col-md-12 col-sm-12'>
                    <div className='search-input-box flight-from'>
                      <label className='form-label'>Country</label>
                      {/* <input
                        className='autocomplete-airport inp-text '
                        id='search-user'
                        type='text'
                        name='Country'
                        onChange={handleChange}
                        autoComplete='off'
                        value={formData.Country}
                        required
                      /> */}
                      <SearchDropdown
                        data={Country.getAllCountries()}
                        placeholder=''
                        value={formData.Country}
                        formData={formData}
                        onSelect={handleCountrySelect}
                      />
                    </div>
                  </div>
                  <div className='col-lg-7 col-md-12 col-sm-12'>
                    <div className='form-group'>
                      <div className='subContent'>
                        <div className='search-input-box departure'>
                          <div
                            onClick={() => setDateRangeOpen(true)}
                            style={{
                              position: 'absolute',
                              left: '0px',
                              right: '0px',
                              width: '100%',
                              height: '100%'
                            }}
                          ></div>
                          <label className='form-label'>Trip Start Date</label>
                          <div className='form-holder'>
                            <input
                              onClick={() => setDateRangeOpen(true)}
                              className='autocomplete-airport inp-text'
                              type='text'
                              name='departure_date'
                              value={
                                formData.departureDate
                                  ? moment(formData.departureDate).format(
                                      'DD MMM YYYY'
                                    )
                                  : formData.departureDate
                              }
                              placeholder=''
                              required
                            />
                            <p>
                              <span>
                                {formData.departureDate
                                  ? moment(formData.departureDate).format(
                                      'dddd'
                                    )
                                  : ''}
                              </span>
                            </p>
                            <DateRangeSelector
                              dateRangeOpen={dateRangeOpen}
                              setDateRangeOpen={setDateRangeOpen}
                              handleOnchangeDate={handleOnchangeDate}
                            />
                          </div>
                        </div>
                        <div className='search-input-box departure'>
                          <div
                            onClick={() => setDateEndOpen(true)}
                            style={{
                              position: 'absolute',
                              left: '0px',
                              right: '0px',
                              width: '100%',
                              height: '100%'
                            }}
                          ></div>
                          <label className='form-label'>Trip End Date</label>
                          <div className='form-holder'>
                            <input
                              onClick={() => setDateEndOpen(true)}
                              className='autocomplete-airport inp-text'
                              type='text'
                              name='departure_date'
                              value={
                                formData.returnDate
                                  ? moment(formData.returnDate).format(
                                      'DD MMM YYYY'
                                    )
                                  : formData.returnDate
                              }
                              placeholder=''
                              required
                            />
                            <p>
                              <span>
                                {formData.returnDate
                                  ? moment(formData.returnDate).format('dddd')
                                  : ''}
                              </span>
                            </p>
                            <EndDateSelector
                              formData={formData}
                              dateRangeOpen={endOpen}
                              setDateRangeOpen={setDateEndOpen}
                              handleOnchangeDate={handleOnchangeEndOpen}
                            />
                          </div>
                        </div>
                        <div className='search-input-box room-box'>
                          <label className='form-label'>Insurance Age</label>
                          <input
                            className='autocomplete-airport air-number inp-text '
                            id='search-user'
                            type='number'
                            name='age'
                            onChange={handleChange}
                            autoComplete='off'
                            value={formData.age}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-7 col-md-12 col-12 enquiry-form'>
                    <div className='row'>
                      <div className='col-md-4  m-b-10'>
                        <div className='form-group'>
                          <input
                            type='text'
                            className='form-control'
                            name='full_name'
                            placeholder='Full Name'
                            value={formData.full_name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className='col-md-4  m-b-10'>
                        <div className='form-group'>
                          <input
                            type='text'
                            className='form-control'
                            name='contact'
                            placeholder='Mobile Number'
                            pattern='^\d*$'
                            value={formData.contact}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className='col-md-4'>
                        <div className='form-group'>
                          <input
                            type='text'
                            className='form-control'
                            name='email'
                            placeholder='Email ID'
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                          <input
                            type='hidden'
                            name='product_type'
                            value='hotels'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-5 col-md-12 col-12'>
                    <div className='recent-box'>
                      <div className='recent-head'>Recent Searches</div>
                      <ul className='recent-list'></ul>
                    </div>
                  </div>
                </div>
                <div className='button-center'>
                  <button type='submit' className='btn search-btn'>
                    <span className='button-text'>ENQUIRE NOW</span>
                  </button>
                </div>
              </form>
              {success && (
                <div className='success-popup'>Thank you for your enquiry!</div>
              )}
            </div>
          </div>
        </div>
        <SliderImages data={sliderImages[0]?.displayImages || []} />
      </div>
    </div>
  )
}
export default Insurance
